export function FrontPage() {
  let galleryEls = document.querySelectorAll('[data-gallery');
  let galleries = [];

  const init = () => {
    galleryEls.forEach((el, i) => {
      const galleryImgs = el.querySelectorAll('[data-gallery-img]');

      galleries[i] = {};
      galleries[i].imgs = galleryImgs;
      galleries[i].numImgs = galleryImgs.length;
      galleries[i].counter = 0;

      galleryImgs.forEach((el, i) => {
        i === 0 ? false : (el.style.opacity = 0);
      });

      if (galleryImgs.length > 1) {
        setInterval(() => {
          if (window.getComputedStyle(el).display === 'none') {
            return;
          }

          crossFade(galleries[i]);
        }, 3000);
      }
    });
  };

  const crossFade = (gallery) => {
    gallery.imgs.forEach((el, i) => {
      el.style.opacity = i === gallery.counter ? 1 : 0;
      el.style.zIndex = i === gallery.counter ? 1 : 0;
    });

    gallery.counter = gallery.counter === gallery.numImgs - 1 ? 0 : (gallery.counter += 1);
  };

  return { init };
}
